module.exports = __webpack_public_path__ + "application/templates/default/inner/blocked-user/blocked-user.template.html";